import styled from 'styled-components';
import { defaultStyle } from '../../../style';

interface Props {
    percMultiplier: number,
}

const specificColors = {
    grey: 'rgba(167, 177, 192, 1)',
};
const boxShadow = '0px 4px 4px rgba(0, 0, 0, 0.1)';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-content: center;
`;

export const Appbar = styled.div`
    background-color: ${defaultStyle.colors.blue};
    height: 10%;
    padding: 0% 5%;

    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: ${boxShadow};
`;
export const Profile = styled.div`
    aspect-ratio: 1;
    height: 50%;

    border-radius: 50%;
    background-color: ${defaultStyle.colors.light};
    box-shadow: ${boxShadow};
`;
export const Header = styled.div<Props>`
    width: 40%;
    border-radius: ${(p) => `${0.1 + p.percMultiplier * 0.3}rem`};
    height: 40%;
    background-color: ${defaultStyle.colors.light};
    box-shadow: ${boxShadow};
`;
export const Dots = styled.div`
    aspect-ratio: 1;
    height: 50%;

    display: flex;
    justify-content: center;
    align-items: center;
    & > div {
        height: 70%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        & > div {
            height: 20%;
            aspect-ratio: 1;
            border-radius: 50%;
            background-color: ${defaultStyle.colors.light};
            box-shadow: ${boxShadow};
        }
    }
`;

const contentHorizontalPadding = '10%';
export const Content = styled.div`
    background-color: ${defaultStyle.colors.light};
    flex: 1;
    padding: 10% ${contentHorizontalPadding} 0;

    display: flex;
    flex-direction: column;
`;
export const Title = styled.div<Props>`
    width: 60%;
    height: 6%;
    border-radius: ${(p) => `${0.1 + p.percMultiplier * 0.3}rem`};
    margin-bottom: 6%;

    box-shadow: ${boxShadow};
    background-color: ${specificColors.grey};
`;
export const HorizontalCards = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 15%;
    & > div {
        aspect-ratio: 1;
        width: 30%;
        border-radius: 10%;
        background-color: ${specificColors.grey};
        margin-right: 2%;
        box-shadow: ${boxShadow};
    }
`;
export const VerticalCards = styled.div<Props>`
    display: flex;
    flex-direction: column;
    padding-right: ${contentHorizontalPadding};
    width: 100%;
    flex: 1;
    & > div {
        border-radius: ${(p) => `${0.15 + p.percMultiplier * 0.25}rem`};
        width: 100%;
        height: 100%;
        background-color: ${specificColors.grey};
        margin-bottom: 2%;
        box-shadow: ${boxShadow};
    }
`;
